
<div class="AuxHUD FlexSplitter">
  <div class="AuxHUD_Group">
    <div
      v-if="hasWidget('StrokeColor')"
      class="AuxHUD_Item js-StrokeColorButton"
      v-on:click="openStrokeColorPicker"
      title="Stroke color"
    >
      <div class="ColorBox m-stroke" v-bind:style="strokeColorBoxStyle">
        <div
          class="ColorBox_Inner"
          v-bind:style="strokeColorBoxInnerStyle"
        ></div>
      </div>
    </div>

    <div
      v-if="hasWidget('FillColor')"
      class="AuxHUD_Item js-FillColorButton"
      v-on:click="openFillColorPicker"
      title="Fill color"
    >
      <div class="ColorBox m-fill" v-bind:style="fillColorBoxStyle">
        <div
          class="ColorBox_Inner"
          v-bind:style="fillColorBoxInnerStyle"
        ></div>
      </div>
    </div>

    <div
      v-if="hasWidget('FillColorForSticky')"
      class="AuxHUD_Item js-FillColorForStickyButton"
      v-on:click="openFillColorForStickyPicker"
      title="Sticky note color"
    >
      <div class="ColorBox m-fill-sticky" v-bind:style="fillColorBoxStyle">
        <div
          class="ColorBox_Inner"
          v-bind:style="fillColorForStickyBoxInnerStyle"
        ></div>
      </div>
    </div>

    <div
      v-if="hasWidget('StrokeWidth')"
      class="AuxHUD_Item js-StrokeWidthButton"
      v-on:click="openStrokeWidthPicker"
      title="Stroke width"
    >
      <div class="StrokeWidthIndicator">
        <div
          class="StrokeWidthIndicator_Circle"
          v-bind:style="strokeWidthCircleStyle"
        ></div>
      </div>
    </div>

    <div
      v-if="hasWidget('StrokeWidthForEraser')"
      class="AuxHUD_Item js-StrokeWidthButton"
      v-on:click="openStrokeWidthPicker"
      title="Stroke width"
    >
      <div class="StrokeWidthIndicator">
        <div
          class="StrokeWidthIndicator_Circle"
          v-bind:style="strokeWidthForEraserCircleStyle"
        ></div>
      </div>
    </div>

    <div
      v-if="hasWidget('DeleteSelection')"
      v-on:click="deleteSelection"
      v-on:touchstart="deleteSelection"
      title="Delete selected shapes"
      :class="{
        AuxHUD_Item: true,
        CircleShadowButton: true,
        'm-disabled': selections.length <= 0,
      }"
    >
      <img src="/img/icons/trash-outline.svg" />
    </div>

    <div
      v-if="hasWidget('DuplicateSelection')"
      v-on:click="duplicateSelectedShapes"
      v-on:touchstart="duplicateSelectedShapes"
      title="Duplicate selected shapes"
      :class="{
        AuxHUD_Item: true,
        CircleShadowButton: true,
        'm-disabled': selections.length <= 0,
      }"
    >
      <img src="/img/icons/copy-outline.svg" />
    </div>

    <OpacitySlider v-if="hasWidget('Opacity')"></OpacitySlider>

    <div class="QuillToolbarContainer" v-on:mousedown.prevent></div>
  </div>

  <div class="AuxHUD_Group">
    <div
      v-on:click="undo"
      v-on:touchstart="undo"
      title="Undo"
      :class="{
        CircleShadowButton: true,
        AuxHUD_Item: true,
        'm-undo': true,
        'm-disabled': !state.reported.undo.canUndo,
      }"
    >
      <img src="/img/icons/arrow-undo-outline.svg" />
    </div>

    <div
      v-on:click="redo"
      v-on:touchstart="redo"
      title="Redo"
      :class="{
        CircleShadowButton: true,
        AuxHUD_Item: true,
        'm-redo': true,
        'm-disabled': !state.reported.undo.canRedo,
      }"
    >
      <img src="/img/icons/arrow-redo-outline.svg" />
    </div>

    <div
      class="AuxHUD_Item CircleShadowButton m-warning m-variable-width"
      v-if="mayClear"
      v-on:click="clear"
      title="Delete everything"
    >
      <img src="/img/icons/delete-outline.svg" />
      <div class="CircleShadowButton_HoverText m-right">
        <span>Delete everything</span>
      </div>
    </div>
  </div>
</div>
